'use client';

import type { PostCommentSearchItem } from '@ps/api/types';

import { formatPostDate } from '../../functions/format-post-date';
import { CommentAvatar } from './CommentAvatar';

export function CommentRow({ comment }: { comment: PostCommentSearchItem }) {
  const name =
    comment.profile.storeFrontName ?? comment.profile.urlCode ?? 'User';
  const handle = comment.profile.urlCode ? `@${comment.profile.urlCode}` : null;
  return (
    <li className="flex gap-3">
      <CommentAvatar src={comment.profile.avatar} fallback={name} />
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <div className="flex items-baseline gap-2">
          <span className="text-[13px] font-semibold leading-tight">
            {name}
          </span>
          {handle ? (
            <span className="text-[11px] leading-tight text-black/40">
              {handle}
            </span>
          ) : null}
          <span className="ml-auto text-[11px] leading-tight text-black/40">
            {formatPostDate(new Date(comment.createdAt))}
          </span>
        </div>
        <p className="whitespace-pre-wrap text-[13px] leading-snug text-black/85">
          {comment.text}
        </p>
      </div>
    </li>
  );
}
